import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderLabelComponent } from './dynamic-page-builder-label.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderLabelDesignComponent } from './label-design/page-builder-label-design.component';

@NgModule({
    declarations: [
        PageBuilderLabelDesignComponent, DynamicPageBuilderLabelComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderLabelComponent
    ]
})
export class PageBuilderLabelModule {}